import {
  createStandardAction,
  createAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';
import {CHAT_MAX_LINE} from 'constants/config';
import nanoid from 'nanoid';

/**
 * 채팅 리덕스
 */

const ADD_CHAT = 'chat/ADD_CHAT';
const REMOVE_CHAT = 'chat/REMOVE_CHAT';
const CLEAR_CHAT = 'chat/CLEAR_CHAT';

// let nextId: number = 1; // 새로운 채팅 추가 할 때 사용 할 고유 ID 값

export const addChat = createAction(
  ADD_CHAT,
  (action) => (text: string) =>
    action({
      id: nanoid(10),
      text,
    }),
);
export const removeChat = createStandardAction(REMOVE_CHAT)();
export const clearChat = createStandardAction(CLEAR_CHAT)();

type actions = {
  addChat: typeof addChat;
  removeChat: typeof removeChat;
  clearChat: typeof clearChat;
};
type ChatAction = ActionType<actions>;

export type TChat = {
  id: string;
  text: string;
};

type ChatState = TChat[];

const initialState: ChatState = [];

const chat = createReducer<ChatState, ChatAction>(initialState, {
  [ADD_CHAT]: (state, action) =>
    state.concat({
      ...action.payload,
    }),
  [REMOVE_CHAT]: (state) => state.filter((_, idx) => idx >= CHAT_MAX_LINE),
  [CLEAR_CHAT]: () => initialState,
});

export default chat;
